import jwtDecode, { JwtPayload } from 'jwt-decode';
import { DevsiteCookies } from 'shared/models/cookies';
import { getCookie } from 'modules/common/DevsiteCookies';
import DevsiteEnv from '../DevsiteEnv';

export const getToken = () => {
  // BFF HttpOnly cookie is not readable from JS.
  if (DevsiteEnv.BFF_ENABLED) return '';
  return getCookie(DevsiteCookies.WDAY_ACCESS_TOKEN);
};

// currently only used outside of app preview, so it's okay to get exp from token
export function getTokenExpiration(token: string): number | null {
  const decoded = jwtDecode<JwtPayload>(token);
  // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
  return !isNaN(decoded.exp) ? decoded.exp * 1000 : null;
}
